import React from "react";
import {
  breakpointClasses,
  cn,
  resolveElement,
  splitBreakpointProps,
} from "@/lib/utils";
import type { BreadcrumbLinkProps } from "../types";

function BreadcrumbLink<E extends React.ElementType = "a">({
  as,
  asChild,
  className,
  ...props
}: BreadcrumbLinkProps<E>) {
  const Component = resolveElement(asChild, as, "a");
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  if (process.env.NODE_ENV !== "production" && as && asChild) {
    console.warn(
      `[Breakcrumb] 'asChild' renders the child element; 'as' is ignored.`,
    );
  }

  return (
    <Component
      data-slot="breadcrumb-link"
      className={cn("transition-colors", className, classes)}
      {...native}
    />
  );
}

BreadcrumbLink.displayName = "Breadcrumb.Link";

export default BreadcrumbLink;
